import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { MobilityConfigurationRead, PersonalMobilityConfigurationRead } from '@ragu-components/ord-types';

const Mobility = React.lazy(async () => import('./Mobility'));

export const adminMobilityResource: OrdResourceProps = {
  key: Resources.mobility_configurations,
  name: Resources.mobility_configurations,
  list: <Mobility />,
  options: {},
  recordRepresentation: (record: MobilityConfigurationRead): string => record.name,
};

const PersonalMobility = React.lazy(async () => import('./PersonalMobility'));

export const personalMobilityResource: OrdResourceProps = {
  key: `me/${Resources.mobility_configurations}`,
  name: `me/${Resources.mobility_configurations}`,
  list: <PersonalMobility />,
  options: {},
  recordRepresentation: (record: PersonalMobilityConfigurationRead): string => record.name,
};
